import { render, staticRenderFns } from "./basicsgoodList.vue?vue&type=template&id=26d31413&scoped=true"
import script from "./basicsgoodList.vue?vue&type=script&lang=js"
export * from "./basicsgoodList.vue?vue&type=script&lang=js"
import style0 from "./basicsgoodList.vue?vue&type=style&index=0&id=26d31413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d31413",
  null
  
)

export default component.exports